import moment from 'moment'
import * as jose from 'jose'
import storage from 'src/components/Core/Utils/storage'
import { SCOPES } from './authConfig'

import { AccountInfo } from '@azure/msal-common'
import { IPublicClientApplication } from '@azure/msal-browser'
import {
  ResponseCallbackType,
  ScopeKeys,
  UserStatusType,
  NavigateMapType,
  ParseUserStatusOutput,
  StatusType,
  statusTypes,
} from './types'

const TIMESTAMP_FORMAT = 'DD/MM/YYYY HH:mm:ss'

// It returns true if the token is expired
export const checkTokenExpiration = (scope: ScopeKeys = 'main'): boolean => {
  const token = storage.get(storage?.keys?.[scope as ScopeKeys]?.token)
  if(!token) return true

  const tableData = jose?.decodeJwt(token)
  const exp: string = moment(tableData?.exp * 1000).format(TIMESTAMP_FORMAT)
  const diffMinutes: number = moment().diff(moment(exp, TIMESTAMP_FORMAT), 'minutes')
  return diffMinutes >= -2
}

const getTokenInitialState = (scope: ScopeKeys) => {
  if(checkTokenExpiration(scope)) return null

  return storage.get(storage?.keys?.[scope as ScopeKeys]?.token)
}

export const getToken = (
  scope: ScopeKeys,
  instance: IPublicClientApplication,
  account: AccountInfo,
  responseCallback?: ResponseCallbackType,
  errorCallback?: ErrorCallback
) => {
  if(scope === 'main') storage.set(storage?.keys?.main?.user, account)

  const request = {
    scopes: [SCOPES?.[scope as ScopeKeys]],
    account
  }

  const storeToken: ResponseCallbackType = accessToken => {
    storage.set(storage?.keys?.[scope as ScopeKeys]?.token, accessToken)
    if(responseCallback) responseCallback(accessToken)
  }

  return instance
    .acquireTokenSilent(request)
    .then(response => {
      const { accessToken } = response
      if(accessToken) storeToken(accessToken)
      return response
    })
    .catch(error => {
      console.error('getToken error', error)
      if(errorCallback) errorCallback(error)
    })
}

const parseUserStatus = (userStatus: UserStatusType): ParseUserStatusOutput => {
  const navigateMap: NavigateMapType = {
    Rejected: '/rejected',
    Hold: '/hold',
    Prospect: '/onboarding',
    Client: '/home',
    Employee: '/home',
    Clearance: '/statements',
  }

  const { status } = userStatus

  const onboardingType: string = status === 'Prospect' ? '/loading/0' : ''

  return ({
    navigateTo: `${navigateMap?.[status as StatusType] || '/hold'}${onboardingType}`
  })
}

function checkUserStatus(jsonString: string): StatusType {
  const status = statusTypes.find(validName => validName === jsonString)
  if(status) {
    return status
  }
  throw new Error('Invalid User Status.')
}

export default {
  getTokenInitialState,
  getToken,
  checkTokenExpiration,
  parseUserStatus,
  checkUserStatus,
}
